export default __webpack_public_path__ + "static/media/car.509b45b0.svg";